import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4 leading-4.5" }
const _hoisted_2 = { class: "whitespace-nowrap" }

import { store } from "@/state/store";
import { switchLoginAndRegister } from "@/services/sharedFunctions";
import { $t } from "@/main";

export default /*#__PURE__*/_defineComponent({
  __name: 'IntroductionText',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    _createTextVNode(_toDisplayString(_unref($t)(_unref(store).isLogin ? "login.formText" : "registration.formText")) + " ", 1),
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("button", {
        class: "cursor-pointer font-semibold text-black-primary underline hover:text-black",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(switchLoginAndRegister)('Top')))
      }, _toDisplayString(_unref($t)(_unref(store).isLogin ? "login.switch_link" : "registration.switch_link")), 1)
    ])
  ]))
}
}

})